import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
const OPTIONS = [
    { code: 'en', label: 'English' },
    { code: 'ur', label: 'اردو' },
    { code: 'ar', label: 'العربية' },
];
export function LanguageSelector() {
    const { i18n } = useTranslation();
    return (_jsxs("label", { className: "text-xs text-muted-foreground", children: [_jsx("span", { className: "sr-only", children: "Language" }), _jsx("select", { value: i18n.language, onChange: (e) => void i18n.changeLanguage(e.target.value), className: "rounded-md border border-input bg-background px-2 py-1 text-xs", children: OPTIONS.map((opt) => (_jsx("option", { value: opt.code, children: opt.label }, opt.code))) })] }));
}
